import api from "../axiosIntercepture";

export const getPackingSizeData = async (value) => {
    try {
        const response = await api.post('/packing/getPackingSize', value);
        return response.data?.data;
    }
    catch (err) {
        throw err?.response?.data || err;
    }
}


export const getpackingDataAPI = async (data) => {
    try {
        const response = await api.post('/packing/getPackingData', data);
        return response?.data;
    }
    catch (err) {
        throw err?.response?.data || err;
    }
}


export const savePackingDataAPI = async (value) => {
    try {
        const response = await api.post('/packing/savePackingData', value);
        return response?.data;
    }
    catch (err) {
        throw err?.response?.data || err;
    }
}


export const getPackingListAPI = async (page, pageSize) => {
    try {
        const response = await api.post(`packing/getPackinglist?page=${page + 1}&pageSize=${pageSize}`);
        return response?.data.data;
    }
    catch (err) {
        throw err?.response?.data || err;
    }
}


export const getPkgIdData = async (data) => {
    try {
        const response = await api.post('/packing/getPkgID', data);
        return response?.data;
    }
    catch (err) {
        throw err?.response?.data || err;
    }
}


export const updatePkgMgtAPI = async (data, id) => {
    try {
        const response = await api.post(`/packing/updatePkgMgtData/${id}`, data);
        return response?.data;
    }
    catch (err) {
        throw err?.response?.data || err;
    }
}


